import { createApiRef } from '@backstage/core-plugin-api';
import { SecurityInsightsClient } from './SecurityInsightsClient';

export const securityInsightsApiRef = createApiRef<SecurityInsightsClient>({
  id: 'plugin.security-insights.api',
});
